import { parse } from './parse';
import { stringify } from './stringify';

export { parse, stringify };
export default { parse, stringify };
